export default "__VITE_ASSET__Cpcyun_m__"